// extracted by mini-css-extract-plugin
export default {"carCard":"CarInfo_carCard__3kFN9","detailsGrid":"CarInfo_detailsGrid__mqUZb","detailItem":"CarInfo_detailItem__MYjho","label":"CarInfo_label__GjUGP","value":"CarInfo_value__X3B1q"};